let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gdtyS")).then(() => parcelRequire('5pzkP'));